import request from "@/utils/request";
import { ENABLE_API_DBG } from "@/appConfig.js";

function getContent(params) {
  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(params)) {
    if (!Array.isArray(value)) {
      qsParams.append(key, value);
    } else {
      value.forEach(elem => qsParams.append(key, elem));
    }
  }

  ENABLE_API_DBG &&
    console.log(
      `api.asset.getContent: params = ${JSON.stringify(
        params
      )}, qsParams = ${qsParams.toString()}`
    );

  return request({
    url: `/asset?${qsParams.toString()}`,
    method: "get",
    data: params,
  });
}

function validateName(params) {
  const qsParams = new URLSearchParams();
  for (let [key, val] of Object.entries(params)) {
    qsParams.append(key, val);
  }
  const url = `/asset/availability?${qsParams.toString()}`

  ENABLE_API_DBG &&
    console.log(`api.asset.validateName: url = ${url}`);

  return request({
    url,
    method: "get",
  });
}

function getAssetSize(itemId) {
  return request({
    url: `/asset/size/${itemId}`,
    method: "get",
  });
}

function getAsset(itemId) {
  return request({
    url: `/asset/${itemId}`,
    method: "get",
  });
}

function copyAsset(params) {
  ENABLE_API_DBG &&
    console.log(`api.asset.copyAsset: params = ${JSON.stringify(params)}`);
  return request({
    url: `/asset/copy`,
    method: "post",
    data: params,
  });
}

function moveAsset(params) {
  ENABLE_API_DBG &&
    console.log(`api.asset.moveAsset: params = ${JSON.stringify(params)}`);
  return request({
    url: `/asset/move`,
    method: "post",
    data: params,
  });
}

function createFolder(params) {
  ENABLE_API_DBG &&
    console.log(`api.asset.createFolder: params = ${JSON.stringify(params)}`);
  return request({
    url: `/asset`,
    method: "post",
    data: params,
  });
}

function renameAsset(params) {
  const { id, ...outParams } = params;
  const url = `/asset/${id}`;
  ENABLE_API_DBG &&
    console.log(
      `api.asset.update: url = ${url}, outParams = ${JSON.stringify(outParams)}`
    );
  return request({
    url,
    method: "patch",
    data: outParams,
  });
}
function update(params) {
  const { id, ...outParams } = params;
  const url = `/asset/${id}`;
  ENABLE_API_DBG &&
    console.log(
      `api.asset.update: url = ${url}, outParams = ${JSON.stringify(outParams)}`
    );
  return request({
    url,
    method: "patch",
    data: outParams,
  });
}
function remove(itemId) {
  return request({
    url: `/asset/${itemId}`,
    method: "delete",
  });
}
function download(itemId) {
  return request({
    url: `/asset/download/${itemId}`,
    method: "get",
    responseType: 'blob'
  });
}
function createWeatherAsset(params) {
  return request({
    url: `/asset/weather`,
    method: "post",
    data: params,
  });
}

function createSlideshowAsset(params) {
  return request({
    url: `/asset/slideshow`,
    method: "post",
    data: params,
  });
}

function geocodeCity(city) {
  return request({
    url: `/weather-bmp-api/geocode?city=${encodeURIComponent(city)}`,
    method: "get",
  });
}

export default {
  getContent,
  createFolder,
  renameAsset,
  validateName,
  remove,
  getAsset,
  copyAsset,
  moveAsset,
  getAssetSize,
  download,
  update,
  createWeatherAsset,
  createSlideshowAsset,
  geocodeCity,
};
